export default function TicketStatusPage() {
  return (
    <div>
      <h1>Ticket Status</h1>
      <p>Acompanhamento de tickets abertos.</p>
    </div>
  );
}
